import React, { useState } from 'react';
import {
  Col,
  Modal,
  Row,
} from 'antd';
import { Button } from 'components';
import { Licencias } from 'assets';
import styled from 'styled-components';
import { ENV_NAME, ENV_NAMES_ENUM, REPUVE } from 'utils/env';

/**
 * Componente que muestra un banner modal para Licencias
 * @returns {JSX.Element} Componente BannerTarjetas
 */
export default function BannerTarjetas() {
  const [visiblebanner, setVisiblebanner] = useState(ENV_NAME === ENV_NAMES_ENUM.NAYARIT
    && !REPUVE);

  return (
    <StyledModal
      visible={visiblebanner}
      footer={(
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Button
              $accent
              block
              onClick={() => setVisiblebanner(false)}
            >
              Cerrar
            </Button>
          </Col>
        </Row>
      )}
      onCancel={() => setVisiblebanner(false)}
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Tarjetas />
        </Col>
      </Row>
    </StyledModal>
  );
}

/**
 * Modal estilizado con dimensiones responsivas
 */
const StyledModal = styled(Modal)`
  @media (max-width: 576px) {
    width: 100% !important;
    max-width: 100% !important;
  }

  @media (min-width: 577px) and (max-width: 768px) {
    width: 80% !important;
    max-width: 450px !important;
  }

  @media (min-width: 769px) {
    width: 400px !important;
    max-width: 630px !important;
  }
`;

/**
 * Componente de imagen estilizado para el banner
 */
const Tarjetas = styled.img.attrs(({
  src: Licencias,
  alt: 'Tarjetas',
}))`
  width: 100%;
  height: auto;
  max-height: 70vh;
  object-fit: contain;
`;
